interface UsernameValidationResult {
  isValid: boolean
  error?: string
}

/**
 * 验证用户名是否符合规则
 * 规则：
 * 1. 不能有空格
 */
export function validateUsername(username: string): UsernameValidationResult {
  if (username.length === 0) {
    return {
      isValid: false,
      error: 'Username is required',
    }
  }

  if (/\s/.test(username)) {
    return {
      isValid: false,
      error: 'Username must not contain spaces',
    }
  }

  return {
    isValid: true,
  }
}
